import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_NEW_REDEEM_DIALOG } from "../../../store/redeem/types";

//action
import { getAgencyProfile } from "../../../store/agency/action";
import { getSetting } from "../../../store/setting/action";
import { createAgencyRedeem } from "../../../store/myRedeem/action";

const AgencyRedeemCreate = () => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector((state) => state.myRedeem);
  const { agencyProfile } = useSelector((state) => state.agency);
  const { setting } = useSelector((state) => state.setting);

  const agency = localStorage.getItem("AGENCY");

  const [mongoId, setMongoId] = useState("");
  const [description, setDescription] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("");
  const [errors, setError] = useState({
    description: "",
    paymentGateway: "",
    balance: "",
  });

  useEffect(() => {
    if (dialogData) {
      setMongoId(dialogData._id);
      setDescription(dialogData.description);
      setPaymentGateway(dialogData.paymentGateway);
    }
  }, [dialogData]);

  useEffect(() => {
    dispatch(getSetting());
    dispatch(getAgencyProfile(JSON.parse(agency)?._id));
  }, [agency]);

  useEffect(
    () => () => {
      setError({
        description: "",
        paymentGateway: "",
        balance: "",
      });
      setMongoId("");
      setDescription("");
      setPaymentGateway("");
    },
    [open]
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const closePopup = () => {
    dispatch({ type: CLOSE_NEW_REDEEM_DIALOG });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !description ||
      !paymentGateway ||
      agencyProfile?.currentBalance < setting?.minRcoinForCashOutAgency
    ) {
      const error = {};

      if (!description) error.description = "Description is required!";
      if (!paymentGateway)
        error.paymentGateway = "Payment Gateway is required!";
      if (agencyProfile?.currentBalance < setting?.minRcoinForCashOutAgency)
        error.balance = "Insufficient Balance !";
      return setError({ ...error });
    }

    const data = {
      id: mongoId,
      agencyId: agencyProfile?._id,
      description,
      paymentGateway: paymentGateway,
    };

    dispatch(createAgencyRedeem(data));

    closePopup();
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">
            Redeem Request
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="form-group">
              <label className="text-gray mb-2">
                Current Balance :{" "}
                {agencyProfile?.pendingWithdrawableCoin
                  ? agencyProfile?.pendingWithdrawableCoin
                  : 0}
              </label>
            </div>
            <div className="form-group">
              <label className="text-gray mb-2">
                Minimum Balance For Cash Out :{" "}
                {setting?.minRcoinForCashOutAgency
                  ? setting?.minRcoinForCashOutAgency
                  : 0}
              </label>
            </div>
            <div className="d-flex flex-column">
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="text-gray mb-2">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Description"
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              description: "Description is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              description: "",
                            });
                          }
                        }}
                      />
                      {errors.description && (
                        <div className="ml-2 mt-1">
                          {errors.description && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.description}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 mt-3">
                    <div className="form-group">
                      <label className="text-gray mb-2">Payment Gateway</label>
                      <select
                        class="form-select form-control"
                        aria-label="Default select example"
                        value={paymentGateway}
                        // placeholder="Select Payment Method... "
                        onChange={(e) => {
                          setPaymentGateway(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              paymentGateway: "Payment Gateway is required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              paymentGateway: "",
                            });
                          }
                        }}
                      >
                        <option value="" disabled selected>
                          Select Payment Method...
                        </option>
                        {setting?.paymentGateway?.map((item, index) => {
                          return (
                            <>
                              <option value={item} key={index}>
                                {item}
                              </option>
                            </>
                          );
                        })}
                      </select>
                      {errors.paymentGateway && (
                        <div className="ml-2 mt-1">
                          {errors.paymentGateway && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.paymentGateway}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {errors.balance && (
                    <div className="ml-2 mt-1">
                      {errors.balance && (
                        <div className="pl-1 text__left mt-3">
                          <span className="text-red">{errors.balance}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="mt-5">
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AgencyRedeemCreate;
